import logo from "@/assets/logo.svg";
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import { ComponentProps } from "react";
import NavMain from "@/v2/navigation/NavMain";
import { NavUser } from "@/components/nav-user";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { Separator } from "@/components/ui/separator";

interface AdminSidebarProps extends ComponentProps<typeof Sidebar> {
    sidebarWidth: number;
}

export function AdminSidebar({ sidebarWidth, ...props }: AdminSidebarProps) {
    const user = useSelector((state: RootState) => state.user.value);
    return (
        <Sidebar variant="inset" {...props} style={{ width: sidebarWidth }}>
            <SidebarHeader>
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton size="lg" asChild>
                            <div className="flex items-center justify-center gap-2">
                                <img
                                    src={logo}
                                    alt="Manage Matey"
                                    className="max-h-12 p-1"
                                />
                            </div>
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarHeader>
            <SidebarContent>
                <div className="mb-3">
                    <Separator className="absolute left-0 bg-primary" />
                </div>
                <NavMain />
            </SidebarContent>
            <SidebarFooter>
                <NavUser user={user} />

                <div className="mt-auto flex justify-center">
                    <Separator className="absolute left-0 bg-primary" />
                    <div className="mt-2 line-clamp-1 text-sm font-medium text-muted-foreground">
                        Powered By
                        <a
                            href="https://lofritex.com"
                            target="_blank"
                            referrerPolicy="origin"
                            className="ml-1 inline-block bg-gradient-to-b from-blue-300 to-blue-600 bg-clip-text text-transparent"
                        >
                            Lofritex
                        </a>
                    </div>
                </div>
            </SidebarFooter>
        </Sidebar>
    );
}
